import React from 'react';
import Bullet from '../bullet';
import { useSelector } from 'react-redux';
import { SystemText } from '@salesperformanceint/e4shared';
import ProgressBar from '../progressBar';
import { translateCourse } from 'helpers/translations';

export const CourseCard = ({ course, noShadow }) => {
    const { prismMultiColumn } = useSelector(state => state.ui);
    const { user } = useSelector(state => state.user);

    course = translateCourse(user.language_Code, course);

    const text = {
        resume: SystemText('General/Resume'), //Resume
        start: SystemText('General/Start'), //Start
        review: SystemText('General/ReviewCourse'), //Review
    };

    return (
        <a data-testid="course-card" href={course.url || '#'} className={`prism-content-box ${noShadow ? 'no-shadow' : ''}`}>
            {prismMultiColumn && (
                <div className="prism-banner">
                    <img src="/dist/img/defaults/course-default.jpg" />
                </div>
            )}
            <div className="prism-content">
                <Bullet type="course" />
                <ProgressBar progress={course.progress} />
                <h3>{course.name}</h3>
                {course.description && <p className="truncate-4">{course.description}</p>}
                <button className="btn btn-primary">
                    {course.progress === 100 ? text.review : course.progress ? text.resume : text.start}
                </button>
            </div>
        </a>
    );
};

export default CourseCard;
